import JassEnum from './enum';

/**
 * type unittype
 */
export default class JassUnitType extends JassEnum {}
